import { Injectable } from '@angular/core';
import { TrailType } from '../dto/trail-type';
import { TrailStatus } from '../dto/trail-status';
import { TrailRollingScheme } from '../dto/trail-rolling-scheme';
import { BoolDto } from '../../../common/dto/bool-dto';
import { Expression } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class TrailPropertiesService {

  constructor() { }

  getAllTrialTypes(): TrailType[] {
    let types = [
      {id: 1, name: 'Annual', description: ''},
      {id: 2, name: 'Proving', description: 'rolling scheme disabled'},
      {id: 3, name: 'Renewal', description: 'rolling scheme disabled'},
      {id: 4, name: 'Modification / update', description: 'rolling scheme disabled'},
      {id: 5, name: 'Mobilization', description: 'rolling scheme disabled'},
      {id: 6, name: 'Assurance', description: 'rolling scheme disabled'}
    ]
    return types;
  }

  getTrialType(list: TrailType[], id?: number): TrailType {
    for(let element of list) {
      if (id === element.id) {
        return element;
      }
    }
    return {id: 0, name: 'N/A'}
  }

  getAllTrialStatus(): TrailStatus[] {
    let types = [
      {id: 1, name: 'In progress'},
      {id: 2, name: 'Completed'}
    ]
    return types;
  }

  getTrialStatus(list: TrailStatus[], id?: number): TrailStatus {
    for(let element of list) {
      if (id === element.id) {
        return element;
      }
    }
    return {id: 0, name: 'N/A'}
  }

  getAllTrialRollingScheme(): TrailRollingScheme[] {
    let types = [
      {id: -1, name: 'disabled'},
      {id: 0, name: 'Year 0'},
      {id: 1, name: 'Year 1'},
      {id: 2, name: 'Year 2'},
      {id: 3, name: 'Year 3'},
      {id: 4, name: 'Year 4'},
    ]
    return types;
  }

  getTrialRollingScheme(list: TrailRollingScheme[], id?: number): TrailRollingScheme {
    for(let element of list) {
      if (id === element.id) {
        return element;
      }
    }
    return {id: -2, name: 'N/A'}
  }

  getAllTrialBinaryStates(): BoolDto[] {
    let states = [
      {state: true, expression: 'Yes'},
      {state: false, expression: 'No'},
    ]
    return states;
  }

  getTrialSetupBinaryState(list: BoolDto[], state?: boolean): BoolDto {
    for(let element of list) {
      if (state === element.state) {
        return element;
      }
    }
    return {state: false, expression: 'N/A'};
  }

}
